export default "__VITE_ASSET__Yx6B7UY9__"